var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRespond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10074",
    "data-name": "Group 10074",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.809,
    height: 30.905,
    viewBox: "0 0 21.809 30.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4832",
    "data-name": "Rectangle 4832",
    width: 21.809,
    height: 30.905,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10073",
    "data-name": "Group 10073",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M14.558,8.145l-1.6,5.939,3.257,3.251A9.5,9.5,0,1,1,2.779,3.9l3.25,3.257,5.916-1.584A1.884,1.884,0,0,1,14.817,5.2a1.863,1.863,0,0,1-.259,2.944m-2.632-.609a2.276,2.276,0,0,1-.279-.941L6.785,7.908,9.167,10.3ZM12.2,13.32l1.322-4.864a2.149,2.149,0,0,1-.952-.263L9.818,10.948Z",
    transform: "translate(0 1.122)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M8.373,22.717l-6.768,0L2.98,15.7a10.536,10.536,0,0,0,4.374,1.8Z",
    transform: "translate(0.462 4.517)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M10.7,24.616H.131v-1.46a1.3,1.3,0,0,1,1.344-1.3l7.9,0A1.3,1.3,0,0,1,10.7,23.171Z",
    transform: "translate(0.038 6.288)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M17.647,9.584A7.232,7.232,0,0,0,11.118.9a.455.455,0,0,1-.337-.558A.471.471,0,0,1,11.307,0a8.126,8.126,0,0,1,7.25,9.636.471.471,0,0,1-.433.412c-.171.013-.542-.156-.478-.466",
    transform: "translate(3.098 0)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M14.928,8.365A4.394,4.394,0,0,0,11.018,3.1a.456.456,0,1,1,.075-.908,5.285,5.285,0,0,1,4.732,6.28.453.453,0,0,1-.484.37c-.17-.009-.473-.188-.413-.479",
    transform: "translate(3.048 0.631)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespond);
export default __webpack_public_path__ + "static/media/respond.f8506660763562fafacc478700264c52.svg";
export { ForwardRef as ReactComponent };